import React, { useEffect, useRef } from 'react';

import * as types from 'constants/actionTypes'
import { useStore, StoreTypes } from 'context';
import classnames from 'classnames';
import styles from './index.module.scss';

export const ExtendedContentCanvas = ({ canvasState, canvasDispatch, canvasWidth, canvasHeight, style, className ,cellSize}) => {
    const canvasRef = useRef(null);
    const fabricRef = useRef(null);
    const { isActive } = canvasState;
    const [{ isShowSubContent,isShowRadicalContent,isShowRadicalProgressModal }] = useStore(StoreTypes.wordGrid);
    // 使用 extendedContent store 的 zoom state 而不是 reader store
    const [{ extendedZoomState }, extendedContentDispatch] = useStore(StoreTypes.extendedContent);
    const { offsetX = 0, offsetY = 0, scale = 1 } = extendedZoomState || {};

    useEffect(() => {
      canvasDispatch({
        type: types.CANVAS_INITIALIZE,
        el: canvasRef.current,
        width: canvasWidth,
        height: canvasHeight,
        isDrawingMode: true,
      });

      // 重置 viewportTransform
      if (canvasState.canvas) {
        canvasState.canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
      }

      // 重置 extendedContent 的 zoom state
      extendedContentDispatch({
        type: types.SET_EXTENDED_CONTENT_SCALE_INFO,
        payload: {
          offsetX: 0,
          offsetY: 0,
          scale: 1,
        },
      });
      // eslint-disable-next-line
    }, [isShowSubContent,isShowRadicalContent,isShowRadicalProgressModal]);

    useEffect(() => {
        canvasDispatch({
            type: types.CANVAS_RESIZE,
            width: canvasWidth,
            height: canvasHeight - 2
        });
    }, [canvasDispatch, canvasHeight, canvasWidth])

    // 使用 extendedContent 的 zoom state 進行 CSS transform 計算
    useEffect(() => {
        if (!fabricRef.current) return;

        const fabricW = canvasWidth;
        const fabricH = canvasHeight;
        const scaleGapX = (fabricW * scale - fabricW) / 2;
        const scaleGapY = (fabricH * scale - fabricH) / 2;

        const newScaleX = 1 / scale;
        const newScaleY = 1 / scale;
        const newOffsetX = -(offsetX + scaleGapX);
        const newOffsetY = -(offsetY + scaleGapY);
        
        fabricRef.current.style.transform = `scaleX(${newScaleX}) scaleY(${newScaleY}) translate(${newOffsetX}px,${newOffsetY}px)`;
    }, [canvasHeight, offsetX, offsetY, scale, canvasWidth, isActive]);

    return (
        <div
            ref={fabricRef}
            className={classnames(styles.canvasWrapper, className, {
                [styles.show]: isActive
            })}
            style={style}
        >
            <canvas ref={canvasRef} id='whiteboard-canvas' />
        </div>
    );
};